// extracted by mini-css-extract-plugin
export default {"sidebar":"SideBar_sidebar__D3H2q","active":"SideBar_active__Rbv3N","react-icons":"SideBar_react-icons__nS9Za"};